import type {RouteRecordRaw} from "vue-router";

export const routeName = 'IncomingDocument';

export const route: RouteRecordRaw = {
    name: routeName,
    path: ':id',
    component: () => import('@/pages/Document'),
    props: true,
    meta: {
        isHide: true,
        title: 'incoming'
    }
};